import React from "react";

export const Add = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconly/Broken/Plus">
      <g id="Plus">
        <path
          id="Plus_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7754 11.3594C21.6316 11.5015 21.437 11.5802 21.2348 11.5778V11.5602C20.8122 11.5602 20.4697 11.2177 20.4697 10.7951V8.2533C20.4697 5.20141 18.7986 3.53034 15.7555 3.53034H8.2533C5.2102 3.53034 3.53034 5.2102 3.53034 8.2533V15.7555C3.53034 18.7898 5.2102 20.4697 8.2533 20.4697H15.7555C18.7986 20.4697 20.4697 18.7898 20.4697 15.7555C20.4697 15.3329 20.8122 14.9903 21.2348 14.9903C21.6574 14.9903 22 15.3329 22 15.7555C22 19.6077 19.6077 22 15.7555 22H8.2533C4.39226 22 2 19.6077 2 15.7555V8.2533C2 4.39226 4.39226 2 8.2533 2H15.7555C19.5901 2 22 4.39226 22 8.2533V10.8215C22 11.0236 21.9191 11.2173 21.7754 11.3594ZM12.0352 7.84872C12.1175 7.8487 12.1984 7.8621 12.275 7.88769C12.5937 7.9801 12.8267 8.27419 12.8267 8.62269V11.015H15.4301C15.5203 11.0139 15.6091 11.029 15.6925 11.0587C15.8089 11.0953 15.9158 11.16 16.0032 11.2484C16.1453 11.3921 16.224 11.5868 16.2216 11.7889C16.2217 12.2047 15.8898 12.5445 15.4741 12.5541H15.4213H8.65787C8.59279 12.5526 8.52974 12.5431 8.46964 12.5266C8.12655 12.4494 7.87037 12.1449 7.86631 11.7801C7.86396 11.578 7.94262 11.3833 8.08472 11.2396C8.22682 11.0958 8.42055 11.0149 8.62269 11.015H11.2612V8.6139C11.2707 8.19187 11.6131 7.85336 12.0352 7.84872ZM11.2788 15.3509V14.4714V14.3835C11.2857 14.1805 11.373 13.9886 11.5214 13.85C11.6699 13.7114 11.8674 13.6376 12.0704 13.6447C12.2741 13.6492 12.4675 13.7358 12.6066 13.8848C12.7456 14.0338 12.8187 14.2326 12.8091 14.4362V15.4037C12.8023 15.6067 12.715 15.7986 12.5665 15.9372C12.418 16.0757 12.2206 16.1496 12.0176 16.1425C11.597 16.1235 11.2688 15.7718 11.2788 15.3509Z"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);
